import { Declaration } from 'store/declarations/declaration';
import { DeclarationExternalEntity } from 'store/declarations/enums/common/declaration-external-entity';
import { DeclarationInternalType } from 'store/declarations/enums/common/declaration-internal-type';
import { getMirroredLinksLabel } from './getMirroredLinksLabel';

export type MirroredLinks = {
    label: string;
    isSingle: boolean;
};

const LINKED_H1_LABEL = 'H1';

const isCdsExport = (declaration: Declaration) =>
    declaration.declarationExternalEntity === DeclarationExternalEntity.CDS &&
    declaration.declarationInternalType === DeclarationInternalType.EXPORT;

/**
 * What the declarations table shows next to the declaration type, or undefined when nothing.
 *
 * Normally it comes from `mirroring`. But a CDS export (B1) can carry the link to its H1 in
 * `mirrorDeclarationIdLink` while `mirroring` says 0 created declarations, so the link is the
 * one source that still tells us the H1 exists.
 */
export const getMirroredLinks = (declaration: Declaration | undefined): MirroredLinks | undefined => {
    if (!declaration) return undefined;

    const label = getMirroredLinksLabel(declaration.mirroring);
    if (label) {
        return { label, isSingle: declaration.mirroring?.createdDeclarationsCount === 1 };
    }

    const isLinkedToH1 = Boolean(declaration.mirrorDeclarationIdLink) && isCdsExport(declaration);
    if (isLinkedToH1) {
        return { label: LINKED_H1_LABEL, isSingle: true };
    }

    return undefined;
};
